import { Box, Button, Stack, Typography } from '@mui/material';
import { PRODA_STEPS, colors } from '@scriptpad/shared';
import { StepPaper } from './StepPaper.js';
import type { WizardStepProps } from './WizardRouter.js';

export const Step3OrgInstructions = ({ onAdvance }: WizardStepProps) => (
  <StepPaper>
    <Stack spacing={3}>
      <Typography variant="h3">Get your NASH PKI certificate</Typography>

      <Typography variant="body1" color="text.secondary">
        Great! Now we need your assistance to upload a NASH PKI certificate for your healthcare provider
        organisation. This is done through PRODA by the Organisation Maintenance Officer (OMO) for your
        organisation via the following steps.
      </Typography>

      <Box
        sx={{
          maxHeight: 380,
          overflowY: 'auto',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          p: 3,
          bgcolor: colors.bgWash,
        }}
      >
        <Stack spacing={2.5}>
          {PRODA_STEPS.map((step) => (
            <Box key={step.number}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, color: colors.navy }}>
                Step {step.number} - {step.title}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'pre-line', mt: 0.5 }}>
                {step.body}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Box>

      <Stack
        direction={{ xs: 'column-reverse', sm: 'row' }}
        spacing={{ xs: 1.5, sm: 2 }}
      >
        <Button onClick={() => onAdvance(2)} variant="text">
          Back
        </Button>
        <Button size="large" variant="contained" onClick={() => onAdvance(4)}>
          I've got the certificate
        </Button>
      </Stack>
    </Stack>
  </StepPaper>
);
